<template>
	<div class="iframe-container">
		<iframe class="iframe" :src="src" :width="width" :height="height" :allowfullscreen="allowfullscreen"></iframe>
	</div>
</template>

<script>
export default {
	props: ['node', 'updateAttrs', 'view'],
	computed: {
		src: {
			get() {
				return this.node.attrs.src
			},
			set(src) {
				this.updateAttrs({
					src
				})
			}
		},
		width: {
			get() {
				return this.node.attrs.width
			},
			set(width) {
				this.updateAttrs({
					width
				})
			}
		},
		height: {
			get() {
				return this.node.attrs.height
			},
			set(height) {
				this.updateAttrs({
					height
				})
			}
		},
		allowfullscreen: {
			get() {
				return this.node.attrs.allowfullscreen
			},
			set(allowfullscreen) {
				this.updateAttrs({
					allowfullscreen
				})
			}
		}
	}
}
</script>